import { TripVehicleType } from 'app/constants/delegation/tripVehicleType'

export const getTripVehicleTypeName = (
  tripVehicleType: TripVehicleType,
  translate: (string) => string,
): string => {
  const text: string = TripVehicleType[tripVehicleType]
  return translate(`tripVehicleType.${text}`)
}
